interface InfoRowProps {
  label: string;
  value: React.ReactNode;
}

export function InfoRow({ label, value }: InfoRowProps) {
  return (
    <div className="flex flex-col gap-0.5 py-3 border-b border-outline last:border-0">
      <span className="text-primary text-xs opacity-60 uppercase tracking-wider">{label}</span>
      <span className="text-light text-sm">{value}</span>
    </div>
  );
}
